import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

// AC-1/AC-3 — renders a publisher-controlled `ErrorMessage` (upstream ACR/Azure text) as
// PLAIN TEXT with its line breaks preserved, NEVER as HTML (`developer-portal-log-output-xss`
// precedent — no `dangerouslySetInnerHTML` anywhere). Length-managed: clamped to a fixed
// max-height with its own scrollbar so a long/multi-line message can never push the
// outcome, timeline or actions off screen. Reused both in the above-the-fold failure
// banner and on the failing stage's timeline row (AC-6).
const RunErrorText = ({ message, maxHeight }) => {
	if (!message) {
		return null;
	}

	return (
		<Box
			sx={{
				maxHeight,
				overflowY: 'auto',
				whiteSpace: 'pre-wrap',
				wordBreak: 'break-word'
			}}
		>
			<Typography variant="body2" component="span" color="inherit">
				{message}
			</Typography>
		</Box>
	);
};

export default React.memo(RunErrorText);

RunErrorText.propTypes = {
	message: PropTypes.string,
	maxHeight: PropTypes.number
};

RunErrorText.defaultProps = {
	maxHeight: 160
};
